

































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import { GChart } from "vue-google-charts";
import moment from "moment";
import SliderArrow from "@/shared/components/ui/SliderArrow.vue";
import { FetchState } from "@/shared/types";
import { useExpenseReimbursedSummaryStore } from "@/employee/store/expenseReimbursedSummary";

@Component({
  components: {
    GChart,
    SliderArrow
  }
})
export default class ReimbursedYearlySummary extends Vue {
  expenseReimbursedSummaryStore = useExpenseReimbursedSummaryStore();

  chartOptions = {
    colors: [ "#F0545E" ],
    legend: {
      position: "none"
    },
    tooltip: {
      isHtml: true
    },
    vAxis: {
      format: "currency",
      minValue: 0,
      maxValue: 1,
      viewWindowMode: "pretty"
    }
  };
  monthDisplaySpan = 12;
  selectedEndDate = moment().endOf("month");
  selectedStartDate = moment(this.selectedEndDate).add(1, "days").subtract(this.monthDisplaySpan, "months")
      .startOf("month");

  mounted () {
    this.loadReimbursedBalances();
  }

  get yearSummaryFormatted () {
    return this.expenseReimbursedSummaryStore.yearSummary.map(e => ({ year: e.year, total: formatCurrency(e.amount) }));
  }

  navigateBackPossible (): boolean {
    return moment(this.selectedStartDate) > moment(this.expenseReimbursedSummaryStore.graphStartDate);
  }

  navigateForwardPossible (): boolean {
    return moment(this.selectedEndDate) < moment().subtract(1, "days");
  }

  navigateForward (): void {
    if (this.navigateForwardPossible()) {
      this.selectedStartDate = this.selectedStartDate.add(this.monthDisplaySpan, "months");
      this.selectedEndDate = this.selectedEndDate.add(this.monthDisplaySpan, "months");
      this.expenseReimbursedSummaryStore.setFetchState(FetchState.Uninitialized);
      this.loadReimbursedBalances();
    }
  }

  navigateBack (): void {
    if (this.navigateBackPossible()) {
      this.selectedEndDate = moment(this.selectedEndDate).subtract(this.monthDisplaySpan, "months");
      this.selectedStartDate = moment(this.selectedStartDate).subtract(this.monthDisplaySpan, "months");
      this.expenseReimbursedSummaryStore.setFetchState(FetchState.Uninitialized);
      this.loadReimbursedBalances();
    }
  }

  loadReimbursedBalances () {
    const startDate = this.selectedStartDate.format("YYYY-MM-DD");
    const endDate = this.selectedEndDate.format("YYYY-MM-DD");
    this.expenseReimbursedSummaryStore.load({
      startDate,
      endDate
    });
  }
}
